import React, { useContext } from "react";
import Sidebar from "../components/sidebar";
import Header from "../components/header";
import { AuthContext } from "../utility/AuthContext";
import PatientTests from "./operator/patient-test";

function Dashboard() {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
  const { user } = useContext(AuthContext);
  return (
    <div className="d-flex">
      <Sidebar sidebarCollapsed={sidebarCollapsed} />
      <div className="flex-grow-1">
        <Header setSidebarCollapsed={setSidebarCollapsed} />
        {/* <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}> */}
        {/* Page content area */}
        {user.role === "Operator" && <PatientTests />}
        {/* </div> */}
      </div>
    </div>
  );
}

export default Dashboard;
